import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { getAllDestinationsRedux } from "../../../redux/slices/destinations/destinations.asyncActions";
import { openModal } from "../../../redux/slices/modal/modal.slice";
import { getAllSourcesRedux } from "../../../redux/slices/sources/sources.asyncActions";
import { clearTemplate } from "../../../redux/slices/templates/templates.slice";
import {
    clearPreSelectedDestinationIds,
    clearPreSelectedSourceId,
} from "../../../redux/slices/wizardSourceDestination/wizardSourceDestination.slice";
import SignalWizard from "./SignalWizard.layout";

const mapStateToProps = (state: any) => ({
    language: state.languagesState.languages,
    sources: state.allSourcesState.getAllSources.sources,
    sourcesStatus: state.allSourcesState.getAllSources.status,
    sourcesTypes: state.allSourcesTypesState.sources,
    destinations: state.allDestinationsState.getAllDestinations.destinations,
    destinationsStatus: state.allDestinationsState.getAllDestinations.status,
    template: state.templates,
    preSelectedSourceId:
        state.lastAddedSourceDestinationState.preSelectedSourceId,
    preSelectedDestinationIds:
        state.lastAddedSourceDestinationState.preSelectedDestinationIds,
    isModalOpen: state.modal.isOpen,
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchGetSources: () => dispatch(getAllSourcesRedux()),

    dispatchGetDestinations: () => dispatch(getAllDestinationsRedux()),
    dispatchOpenModal: (payload: any) => dispatch(openModal(payload)),
    dispatchClearPreSelectedSourceId: () =>
        dispatch(clearPreSelectedSourceId()),
    dispatchClearPreSelectedDestinationIds: () =>
        dispatch(clearPreSelectedDestinationIds()),
    dispatchClearTemplate: () => dispatch(clearTemplate()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(SignalWizard);
